<template>
<el-dialog :visible.sync="show" title="导入查单" width="410px">
  <div class="content">
    <div style="padding-bottom: 12px;">
      <el-button type="text" @click="downloadTemp">导入模版</el-button>
    </div> 
    <div class="upload-wrap">
      <el-upload
        class="upload-demo"
        drag
        accept=".xls, .xlsx"
        :limit="1"
        :auto-upload="false"
        :file-list="fileList"
        :on-change="handleUploadChange"
        :on-remove="() => fileList = []"
        ref="upload"
        action="#">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">点击或拖拽上传文件</div>
        <div class="el-upload__tip" slot="tip">请先下载导入模版，填入数据后，再进行订单上传 <br />
          数量1，大小2M以内，支持格式xls,xlsx</div>
      </el-upload>
    </div>
  </div>
  <!-- 导入结果 -->
  <el-dialog :visible.sync="showRstDialog" append-to-body title="导入查单结果" width="410px">
    <div v-if="importRst">
      已导入数{{ importRst.orderNum }}条，已报单{{ importRst.groupedData['已报单'].length }}条， 未报单{{ importRst.groupedData['未报单'].length }}条，已被其他人报单{{ importRst.groupedData['已被其他人报单'].length }}条
      <!-- 当前账户名下查询到{{ importRst.successNum }}条，未查询到{{ (importRst.orderNum || 0) - (importRst.successNum || 0) }}条 -->
    </div>
    <div slot="footer">
      <el-button size="mini" @click="showRstDialog = false">关闭</el-button>
      <el-button size="mini" @click="exportExcel" :disabled="!(importRst && importRst.orderNum > 0)" type="primary">导出结果表</el-button>
    </div>
  </el-dialog>
  
  <div slot="footer">
    <el-button size="mini" @click="$emit('close')">关闭</el-button>
    <el-button size="mini" :disabled="!fileList.length" @click="submitUpload" type="primary">上传</el-button>
  </div>
</el-dialog>
</template>

<script>
import { getUserId } from '@/utils/getUser'
import { importQuery } from '@/service/apis/order'
import { getFields, getZsFields } from '@/page/component/routes/index/order-manage/order-list/fields.js'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

const dayjs = require('dayjs')
export default {
  name: 'importExportDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }, 
    roleType: {
      type: Number,
      default: null
    },
    reportType: {
      type: String,
      default: ''
    }
  }, 
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    fields () {
      if (this.reportType === 'ZS') {
        return getZsFields(this.roleType)
      }
      return getFields(this.roleType)
    }
  },
  data () {
    return {
      form: {
        qdAccountId0: '',
        qdAccountId: ''
      },
      fileList: [],
      showRstDialog: false,
      importRst: null,
      importParams: null,
      file: null
    }
  },
  watch: {
  },
  methods: {
    exportExcel () {
      const heads = []
      const baseKeys = []
      this.fields.forEach(item => {
        if (typeof item.needExport === 'undefined' || (typeof item.needExport === 'function' && item.needExport(this.roleType))) {
          let label = item.label
          // 下游渠道 不显示开头‘下游’
          if (this.roleType == 4 && label.indexOf('下游') === 0) {
            label = label.replace('下游', '')
          }
          heads.push(label)
          baseKeys.push(item.key)
        }
      })

      heads.push('查询结果')
      console.log('heads:', heads, this.roleType)
      const data = [
        [...heads]
      ]
      const successList = this.importRst.groupedData['已报单'] || []
      const notHaveList = this.importRst.groupedData['未报单'] || []
      const otherList = this.importRst.groupedData['已被其他人报单'] || []
      successList.length && successList.forEach(item => {
        const values = []
        this.fields.forEach(field => {
          if (typeof field.needExport === 'undefined' || (typeof field.needExport === 'function' && field.needExport(this.roleType))) {
            let val = item[field.key] || ''
            if (field.format) {
              val = field.format(item)
            }
            values.push(field.type === 'number' ? { t: 's', v: val } : val)
          }
        }) 

        values.push('已报单')
        data.push(values)
      })

      notHaveList.length && notHaveList.forEach((item) => {
        let values = []
        values.length = heads.length
        values[0] = item
        values[values.length - 1] = '未报单'

        data.push(values)
      })

      otherList.length && otherList.forEach((item) => {
        let values = []
        values.length = heads.length
        values[0] = item.thirdOrderSn || ''
        values[values.length - 1] = '已被他人报单'
        
        data.push(values)
      })
      // 将数据转换为工作表
      const worksheet = XLSX.utils.aoa_to_sheet(data)

      // 创建工作簿并添加工作表
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

      // 生成Excel文件
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })

      // 使用blob和FileReader创建一个URL然后下载
      const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })
      // 
      saveAs(dataBlob, `导入查单结果 ${dayjs().format('YYYYMMDDHHmmss')}.xlsx`)
    },
    downloadTemp () {
      window.open(location.origin + '/template/OrderTemplate.xlsx')
    },
    handleUploadChange (file) {
      this.fileList = [file]
    },
    submitUpload() {
      this.handleUpload()
    },
    closeRstDialog () {
      this.showRstDialog = false
    },
    // 上传excel
    handleUpload () {
      if (!this.fileList.length) return
      const file = this.fileList[0]
      const { size } = file;
      if (size / 1024 / 1024 > 2) {
        this.$message.error('上传文件的大小不能超过2MB')
        this.fileList = []
        return false
      } 
      const opt = {
        accountId: getUserId()
      } 
      const loading = this.$loading({
        lock: true,
        text: '导入中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.45)'
      })
      try {
        // 校验数据 
        importQuery.call(this, file.raw, opt).then(resp => {
          if (resp) {
            // 清空选择文件
            this.fileList = []
            this.importRst = resp
            this.showRstDialog = true
          }
        }).finally(() => {
          loading.close()
        })
         
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style scoped>
.content { 
  line-height: 24px;
  font-size: 14px;
  color: #666;
}
.flex-row {
  line-height: 30px;
}
.upload-wrap {
  padding-top: 16px;
}
</style>
